import axios from './axios';

const CustomizationService = {
  getCustomizations: async (restaurant_id) => {
    try {
      const response = await axios.get(`/restaurants/customization`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  saveCustomization: async (restaurant_id, data) => {
    try {
      const response = await axios.put(`/restaurants/customization`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getMenu: async (restaurant_id) => {
    try {
      const response = await axios.get(`/restaurants/${restaurant_id}/customization/menu`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  saveMenu: async ( data) => {
    try {
      const response = await axios.put(`/restaurants/customization/menu`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getOurStory: async (restaurant_id) => {
    try {
      const response = await axios.get(`/restaurants/${restaurant_id}/customization/our-story`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  saveOurStory: async ( data) => {
    try {
      const response = await axios.put(`/restaurants/customization/our-story`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getCatering: async (restaurant_id) => {
    try {
      const response = await axios.get(`/restaurants/${restaurant_id}/customization/catering`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  saveCatering: async ( data) => {
    try {
      const response = await axios.put(`/restaurants/customization/catering`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getPriceTiers: async () => {
    try {
      const response = await axios.get(`/price-tiers`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  createDomainSetupRequest: async ( data) => {
    try {
      const response = await axios.post(`/restaurant/domain-setup-request`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
      return e.response.data || e;
    }
  },
  getDomainSetupRequests: async ( data) => {
    try {
      const response = await axios.get(`/restaurant/domain-setup-request`);
      return response.data.data;
    } catch (e) {
      console.error(e);
      return e.response.data || e;
    }
  },
};

export default CustomizationService;